module.exports = __webpack_public_path__ + "media/images/2012_Jan_Australia_jones-0b20abfdaac5833420b710c740019868.png";